module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fatal-icons'), _vm._v(" "), _c('div', {
    staticClass: "u-full-width u-d-block"
  }, [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('h2', [_vm._v("Claim Documents")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin u-padding-t-20"
  }, [(_vm.claimType === 'fatal_accident_dependency') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'fatal::dependency.step-9',
        params: {
          id: _vm.claimId
        }
      }
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'fatal_accident_estate') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'fatal::estate.step-6',
        params: {
          id: _vm.claimId
        }
      }
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'lost_years') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'lost::step-8',
        params: {
          id: _vm.claimId
        }
      }
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'personal_injury') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'personal::step-9',
        params: {
          id: _vm.claimId
        }
      }
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#close"
    }
  })])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex a-form-inputs u-flex-wrap u-align-items-flex-end u-margin-bottom-20 u-r-margin-bottom-0"
  }, [_c('div', [_c('div', {
    staticClass: "u-margin-bottom-10 u-bold"
  }, [_vm._v("\n                    Document Type\n                ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "name": "document_type",
      "id": "documentType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.documentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "offer_letter"
    }
  }, [_vm._v("Offer Letter")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "executive_summary"
    }
  }, [_vm._v("Executive Summary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "schedule_of_loss"
    }
  }, [_vm._v("Schedule of Loss")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "comparison_schedule"
    }
  }, [_vm._v("Comparison Schedule")])])]), _vm._v(" "), (_vm.documentType !== 'offer_letter' && _vm.documentType !== '' && _vm.claimType !== 'personal_injury') ? _c('div', {
    staticClass: "u-margin-trbl-0-0-0-10"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-bold"
  }, [_vm._v("\n                    Discount Rate\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "discount_rate",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.discountRate),
      expression: "discountRate",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    staticClass: "u-full-width",
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateDiscountRate]
    }
  }, [_c('option', {
    domProps: {
      "value": -2.00
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.50
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.00
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.50
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.00
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.50
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.00
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.50
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.00
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.50
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.00
    }
  }, [_vm._v("3.00%")])])])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a-button u-margin-trbl-0-0-0-10",
    class: _vm.documentType === '' ? 'disabled' : '',
    attrs: {
      "disabled": _vm.documentType === ''
    },
    on: {
      "click": _vm.createDocument
    }
  }, [_vm._v("Generate\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table u-full-width p-generate-schedule__table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.getGeneratedDocuments), function(document, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(document.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(document.type.replace(/[_-]/g, " ")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parseFloat(document.discount_rate).toFixed(2)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(document.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(document.updated_at)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "200"
      }
    }, [_c('div', {
      staticClass: "u-d-flex u-flex-space-between"
    }, [(_vm.claimType === 'fatal_accident_dependency') ? _c('router-link', {
      staticStyle: {
        "width": "22px"
      },
      attrs: {
        "to": {
          name: 'fatal::dependency.documents.editor',
          params: {
            id: _vm.claimId,
            document_id: index
          }
        }
      }
    }, [(document.type !== 'executive_summary') ? _c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_' + index,
        "tooltip-text": "edit",
        "side": "left",
        "text-width": "110",
        "icon-type": "edit"
      }
    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'fatal_accident_estate') ? _c('router-link', {
      staticStyle: {
        "width": "22px"
      },
      attrs: {
        "to": {
          name: 'fatal::estate.documents.editor',
          params: {
            id: _vm.claimId,
            document_id: index
          }
        }
      }
    }, [(document.type !== 'executive_summary') ? _c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_' + index,
        "tooltip-text": "edit",
        "side": "left",
        "text-width": "110",
        "icon-type": "edit"
      }
    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'lost_years') ? _c('router-link', {
      staticStyle: {
        "width": "22px"
      },
      attrs: {
        "to": {
          name: 'lost::documents.editor',
          params: {
            id: _vm.claimId,
            document_id: index
          }
        }
      }
    }, [(document.type !== 'executive_summary') ? _c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_' + index,
        "tooltip-text": "edit",
        "side": "left",
        "text-width": "110",
        "icon-type": "edit"
      }
    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.claimType === 'personal_injury') ? _c('router-link', {
      staticStyle: {
        "width": "22px"
      },
      attrs: {
        "to": {
          name: 'personal::documents.editor',
          params: {
            id: _vm.claimId,
            document_id: index
          }
        }
      }
    }, [_c('div', {
      staticClass: "u-float-l"
    }, [(document.type !== 'executive_summary') ? _c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_' + index,
        "tooltip-text": "edit",
        "side": "left",
        "text-width": "110",
        "icon-type": "edit"
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (document.type !== 'comparison_schedule') ? _c('a', {
      attrs: {
        "href": '/api/v1/generated-documents/pdf/' + document.id + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'download_schedule_of_loss' + index,
        "tooltip-text": "download",
        "side": "left",
        "text-width": "150",
        "icon-type": "download"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (document.type === 'comparison_schedule') ? _c('a', {
      attrs: {
        "href": '/api/v1/comparison-schedule/pdf/' + document.id + '?document_id=' + document.id + '&discount_rate=' + document.discount_rate + '&access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'download_comparison_schedule' + index,
        "tooltip-text": "download",
        "side": "left",
        "text-width": "150",
        "icon-type": "download"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          return _vm.deleteDocument(document)
        }
      }
    }, [_c('div', {
      staticClass: "u-float-l"
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'delete' + index,
        "tooltip-text": "delete",
        "side": "left",
        "text-width": "110",
        "icon-type": "delete"
      }
    })], 1)])], 1)])])
  }), _vm._v(" "), (_vm.getGeneratedDocuments.length === 0) ? _c('tr', [_vm._m(1)]) : _vm._e()], 2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_c('h2', [_vm._v("Name")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Type")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Discount Rate")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Created")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Updated")])]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                            No claim documents created yet.\n                        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-004605dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/documents/DocumentList.vue
// module id = 1552
// module chunks = 0